import { render, staticRenderFns } from "./PesquisaEstrutura.vue?vue&type=template&id=61a06e89&scoped=true"
import script from "./PesquisaEstrutura.vue?vue&type=script&lang=js"
export * from "./PesquisaEstrutura.vue?vue&type=script&lang=js"
import style0 from "./PesquisaEstrutura.vue?vue&type=style&index=0&id=61a06e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a06e89",
  null
  
)

export default component.exports